export interface FundFamilyTableHead {
  field?: string;
  header?: string;
}
export const searchFundFamilyTableHead: FundFamilyTableHead[] = [
  { field: 'id', header: 'Fund Family ID' },
  { field: 'name', header: 'Fund Family Name' },
  { field: 'legalName', header: 'Legal Name' }
];
